import { FC } from 'react';

import styles from './used-by-item.module.scss';

export interface UsedByItemProps {
    textNumber: string;
    subNumber: string;
    subNumberMaxWidth?: number;
    order?: number;
}

const UsedByItem: FC<UsedByItemProps> = (props) => {
    const { textNumber, subNumber, subNumberMaxWidth } = props;
    return (
        <div className={styles.container}>
            <div className={styles.textNumber} dangerouslySetInnerHTML={{ __html: textNumber || '' }}></div>
            <div className={styles.subNumber} style={{ maxWidth: subNumberMaxWidth }} dangerouslySetInnerHTML={{ __html: subNumber || '' }}></div>
        </div>
    );
};

export default UsedByItem;
